<template>
  <div>
    <el-dialog :visible.sync="GET_BUY_VISIBLE" title="订单结算" width="500px" class="title" :before-close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <p class="payTxt_1">需支付：</p>
        <p class="payTxt_2"><span class="payTxt_3">搜币：{{ totalCoins }}</span><span>积分：{{ totalpoints
        }}</span></p>
        <p class="line line1"></p>
        <p class="payTxt_5">结余：</p>
        <p class="payTxt_6">
          <span class="payTxt_7">搜币：{{ SYcoins }} <span v-if="SYcoins < 0" class="coinsInsu">【余额不足，请<a
                @click="coinsCharge">充值</a>】
            </span></span>
          <span>积分：{{ SYPoins }}<span v-if="SYPoins < 0" class="pointsInsu">【余额不足，请<a @click="pointsCharge">充值</a>】
            </span></span>
        </p>
        <p class="line"></p>
        <p class="payTxt_9">
          <span><span class="dot">·</span>包含<span class="payTxt_10">会员模型：<span class="payTxt_11">{{ memberMouldNum
          }}个</span></span></span>
          <span v-if="memberState === 0" class="membertxt">尊贵的会员已为您节省<span class="payTxt_14">{{ savePoints
          }}</span>积分</span>
          <span v-else>
            <span class="payTxt_12">加入会员</span><span class="payTxt_13">立省<span class="payTxt_14">{{ totalpoints
            }}</span>积分</span>
          </span>

        </p>
        <div class="payTxt_15">
          <p class="payTxt_16">*请您核对订单信息，结账后无法退款</p>
          <div class="payTxt_17"><el-button type="success" plain @click="okFun" v-loading="loading"
              :disabled="SYcoins < 0 || SYPoins < 0">确认支付</el-button></div>
        </div>
      </div>
    </el-dialog>

    <!-- 充值搜币 -->
    <el-dialog :visible.sync="payVisible" title="充值" width="600px" style="padding-top: 5%" :before-close="close">
      <div class="pay-head">
        <span style="font-weight: bold">搜币：</span>
        <div style="margin-top: 15px; padding-left: 10px">
          <el-radio-group v-model="billing" size="medium" @change="billClick">
            <el-radio-button v-for="bill in billings" :label="bill" :key="bill">{{ bill }}</el-radio-button>
          </el-radio-group>
          <el-input-number v-if="billing == '其他'" v-model="inputNum" :min="1" size="small" @change="handleChange"
            controls-position="right"></el-input-number>

        </div>
      </div>
      <div class="pay-style">
        <span style="font-weight: bold">应付金额：</span>
        <div style="margin-top: 15px; padding-left: 10px">
          <span>{{ amount }}元</span>
        </div>
      </div>

      <div class="pay-style">
        <span style="font-weight: bold">扫码支付</span>

        <el-row :gutter="40">
          <el-col :span="10">
            <div style="margin-top: 15px; padding-left: 10px" id="wxQrcodeImg" ref="wxQrcodeImg"></div>
          </el-col>
          <el-col :span="10">
            <div style="margin-top: 15px; padding-left: 10px" id="zxbIframe" ref="zxbIframe">
              <iframe id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe">
              </iframe>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="40">
          <el-col :span="10">
            <img src="~@/assets/wechatPay.png" />
          </el-col>
          <el-col :span="10">
            <img src="~@/assets/zhifubaoPay.png" />
          </el-col>
        </el-row>

        <div style="padding-top: 20px">
          注：若二维码过期失效，请刷新页面重新进入支付！
        </div>
      </div>
    </el-dialog>

    <!-- 实名认证弹窗 -->
    <el-dialog title="身份认证" width="500px" :visible.sync="identityVisible">
      <el-form :model="identityBox" :rules="identityRules" ref="identityBox" label-width="90px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name" style="width: 360px">
          <el-input v-model="identityBox.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard" style="width: 360px">
          <el-input :maxlength="18" v-model="identityBox.idCard"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="identityVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitIdentity">确 定</el-button>
      </span>
    </el-dialog>
    <!--实名认证提示框-->
    <el-dialog title="提示" :visible.sync="fixIdentityVisible" width="30%">
      <span>充值前请先进行实名认证</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fixIdentityVisible = false">取 消</el-button>
        <el-button type="primary" @click="fixIdentity">确 定</el-button>
      </span>
    </el-dialog>

    <!--绑定手机号提示框-->
    <el-dialog title="提示" :visible.sync="fixMobileVisible" width="30%">
      <span>充值前请先绑定手机号</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fixMobileVisible = false">取 消</el-button>
        <el-button type="primary" @click="fixMobile">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="绑定手机" width="500px" :visible.sync="mobilelVisible">
      <el-form :model="mobileBox" :rules="mobileRules" ref="mobileBox" label-width="90px" class="demo-ruleForm">
        <el-form-item label="手机号" prop="account" style="width: 360px">
          <el-input v-model="mobileBox.account"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="randomCode" style="width: 400px">
          <el-input v-model="mobileBox.randomCode" style="width: 200px"></el-input>

          <el-button v-if="!this.timerObj.telTime.num" @click="telCodeFun" type="primary"
            style="margin-left: 10px">验证码</el-button>
          <el-button v-else style="margin-left: 10px">{{ this.timerObj.telTime.num }}s</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="mobilelVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMobile">确 定</el-button>
      </span>
    </el-dialog>
    <openPointRecharge @hiddenPoints="hiddenPoints" v-if="isHidden" @isBuySuccess="isBuySuccess"
      @changeMemType="changeMemType"></openPointRecharge>
    <successRechart :onceNum="onceNum" :isvisib="isvisib" @isBuySuccess="isBuySuccess"></successRechart>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import commonMixin from "@/mixins/commonMixin";
import openPointRecharge from '@/components/openPointRecharge/index.vue'
import successRechart from '@/components/successRechart/index.vue'
import {
  getCart,
  wxQrCode,
  settlementCartApi,
  queryWxPayStatus,
  zfbQrCode,
  queryZfbPayStatus,
  queryUserInfo,
} from "@/api/extra";
import {
  myAccountApi,
  identityApi,
} from "@/api/user";
import {
  bindAccountApi,
  telCodeApi
} from "@/api/login";
import QRCode from "qrcodejs2";

export default {
  mixins: [commonMixin],
  components: {
    openPointRecharge,
    successRechart
  },
  data () {
    const payStylesAll = [
      {
        key: 0,
        label: "积分",
      },
      {
        key: 1,
        label: "搜点",
      },
      {
        key: 2,
        label: "搜币",
      },
    ];
    const payMents = [
      {
        key: 0,
        label: "微信",
      },
      {
        key: 1,
        label: "支付宝",
      },
    ];
    const billings = [100, 500, 1000, "其他"];
    return {
      isHidden: false, // 积分组件显示隐藏
      mobilelVisible: false,
      mobileBox: {},
      mobileRules: {
        account: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^[1-9][0-9]{10}$/,
            message: "请正确输入手机",
            trigger: "blur",
          },
        ],
        randomCode: [
          { required: true, message: "请填写验证码", trigger: "blur" },
        ],
      },
      timerObj: {
        /* 手机号登录倒计时 */
        telTime: {
          loading: false,
          obj: null,
          num: 0,
        },
      },
      list: [],
      assetsIds: [],
      loading: false,
      payStyle: [0, 1, 2],
      payMent: 0,
      billing: "其他",
      payStyles: payStylesAll,
      payMents: payMents,
      billings: billings,
      payVisible: false,
      payBtn: true,
      wxtimer: "", // 定时器
      zfbtimer: "", // 定时器
      userInfo: "",
      inputNum: 1,
      amount: "",
      userRealNameState: "1", // 用户是否有实名信息
      userRealNamePopShow: false, // 用户实名信息弹窗显示隐藏
      /* 用户实名信息 */
      formRealNameReg: {
        username: "",
        userIdNum: "",
      },
      accountInfo: {
        headImgUrl: "",
        backgroundImgUrl: "",
        sex: "",
        fullName: "",
      },
      isIdcard: 0,
      mediaSetObj: {},
      identityBox: {},
      identityRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证", trigger: "blur" }
        ],
      },
      protocol: false,
      identityVisible: false,
      fixIdentityVisible: false,
      fixMobileVisible: false,
      formRealNameRules: {
        username: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]{2,6}$/,
            message: "请输入真实姓名",
            trigger: "blur",
          },
        ],
        userIdNum: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入真实身份证号码",
            trigger: "blur",
          },
        ],
      },
      giftPointsBalance: 0.00,
      incomePointsBalance: 0.00,
      rechargePointsBalance: 0.00,
      incomePointsBuy: 0.00,
      rechargePointsBuy: 0.00,
      mxType: null, // 是否是会员
      giftPoints: null, // 总积分
      rechargePoints: null, // 总搜币
      memberState: null,
      memberType: null, // 0是会员 ，null/1 不是会员
      isvisib: false,
      onceNum: null,

    };
  },
  created () {
    this.getMyAccountApi()
  },
  computed: {
    ...mapGetters(["GET_BUY_VISIBLE", "GET_USER_INFO", "GET_CART_BADGE", "Get_CHECK_LIST", "GET_TOTAL_CONIS", "GET_TOTAL_POINTS", "GET_JS_LISTS"]),
    ...mapMutations({
      SET_USER_INFO: "SET_USER_INFO",
    }),

    totalCoins () {
      let totalCoins
      if (this.GET_TOTAL_CONIS) {
        totalCoins = this.GET_TOTAL_CONIS
        return Number(totalCoins).toFixed(2)
      } else {
        totalCoins = sessionStorage.getItem('TotalCoins')
        return Number(totalCoins).toFixed(2)
      }
    },
    totalpoints () {
      let totalPoints
      if (this.GET_TOTAL_POINTS) {
        totalPoints = this.GET_TOTAL_POINTS
        return totalPoints.toFixed(2)
      } else {
        totalPoints = sessionStorage.getItem('totalpoints')
        return Number(totalPoints).toFixed(2)
      }
    },
    //结余
    SYcoins () { // 剩余搜币
      this.rechargePoints = sessionStorage.getItem('rechargePoints')
      let sycoins = this.rechargePoints - this.GET_TOTAL_CONIS
      return sycoins.toFixed(2)
    },
    SYPoins () { //剩余积分
      if (this.userInfo.giftPoints) {
        let sypoints = this.userInfo.giftPoints - this.GET_TOTAL_POINTS
        return sypoints.toFixed(2)
      }

    },

    getTotal () {
      let giftPoints = 0;
      let points = 0;
      let select = this.Get_CHECK_LIST.filter((item) => item.checked);

      select.forEach((item) => {

        if ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) {
          giftPoints += parseFloat(item.price);
        }
        if (item.priceType == 1) {
          points += parseFloat(item.price);
        }
      });
      giftPoints = giftPoints.toFixed(2); // 花费
      points = points.toFixed(2)

      this.giftPointsBalance = (parseFloat(this.userInfo.giftPoints) - parseFloat(giftPoints)).toFixed(2); //结余

      if (parseFloat(this.userInfo.incomePoints) - points >= 0) {
        this.incomePointsBalance = (parseFloat(this.userInfo.incomePoints) - parseFloat(points)).toFixed(2);
        this.rechargePointsBalance = parseFloat(this.userInfo.rechargePoints).toFixed(2);

      } else {
        this.incomePointsBalance = parseFloat("0").toFixed(2);
        this.rechargePointsBalance = (parseFloat(this.userInfo.rechargePoints) + parseFloat(this.userInfo.incomePoints) - parseFloat(points)).toFixed(2)
      }

      this.incomePointsBuy = (parseFloat(this.userInfo.incomePoints) - parseFloat(this.incomePointsBalance)).toFixed(2)
      this.rechargePointsBuy = (parseFloat(this.userInfo.rechargePoints) - parseFloat(this.rechargePointsBalance)).toFixed(2);

      return {
        giftPoints,
        points,
        select,
      };
    },

    //积分不足充值入口判定
    payLinkSign () {
      // 选中项目
      let select = this.Get_CHECK_LIST.filter((item) => item.checked);

      // 未存在选中资产  或者  支付方式   用户数据未拉取成功时   不展示
      if (select.length == 0 || this.payStyle.length == 0 || !this.userInfo) {
        // 返回不展示
        return false;
      }

      // 默认不触发
      let sign = false;

      // 所选资产总数
      let giftPoints = 0;
      let points = 0;
      select.forEach((item) => {
        if ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) {
          giftPoints += parseFloat(item.price);
        }
        if (item.priceType == 1) {
          points += parseFloat(item.price);
        }
      });

      // 账户资产
      let accountGiftTotal = this.userInfo.giftPoints;
      let accountPointTotal = parseFloat(this.userInfo.incomePoints) + parseFloat(this.userInfo.rechargePoints);
      if (accountPointTotal < points) {
        sign = true;
      }

      // 返回结果
      return sign;
    },
    memberMouldNum () {
      let arr
      arr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && item.mxType === 1)
      return arr.length
    },
    savePoints () {
      let arr
      let sum = 0
      arr = this.Get_CHECK_LIST?.filter(item => ((item.priceType === 0 && item.price !== 0) || item.priceType === 2) && item.mxType === 1) // 被勾选的会员模型
      arr.forEach(i => {
        if (this.memberType == 1) { // 白银
          if (arr.length <= 5) {
            sum += i.price
          }
        } else if (this.memberType == 2) { // 黄金
          if (arr.length <= 30) {
            sum += i.price
          }
        } else if (this.memberType == 3) { // 钻石
          sum += i.price
        }
      })

      return sum;
    }
  },
  methods: {
    getMyAccountApi () {
      myAccountApi().then(res => {
        if (res.code == 200) {
          this.memberType = res.data.memberType
          this.memberState = res.data.memberState
          this.giftPoints = res.data.giftPoints
          this.rechargePoints = res.data.rechargePoints
          sessionStorage.setItem('memberState', res.data.memberState)
          sessionStorage.setItem('memberType', res.data.memberType)
          sessionStorage.setItem('giftPoints', res.data.giftPoints)
          sessionStorage.setItem('rechargePoints', res.data.rechargePoints)
        }
      })
    },
    hiddenPoints (state) {
      this.isHidden = state
    },
    isBuySuccess (val) {
      this.isvisib = val
    },
    changeMemType (val) {
      this.onceNum = val
    },
    fixMobile () {
      this.fixMobileVisible = false;
      this.$confirm(
        "您正在绑定手机/邮箱，如果该手机/邮箱已经在本站注册用户，为保证安全，将无法进行绑定！如有疑问请提交工单",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "我已了解",
          cancelButtonText: "提交工单",
        }
      )
        .then(() => {
          this.mobileBox = {};
          this.mobilelVisible = true;
        })
        .catch((action) => {
          /* 点击取消按钮 */
          if (action === "cancel") {
            this.$router.push("/user/workorder");
          } else {
          }
        });
    },
    // /* 短信倒计时 */
    timerTelClick () {
      // alert(timeMax)
      // this.stopTelTime();
      this.timerObj.telTime.num = 120;

      const TelTickFun = () => {
        --this.timerObj.telTime.num;

        if (this.timerObj.telTime.num <= 0) {
          this.timerObj.telTime.num = 0;
          clearInterval(this.timerObj.telTime.obj);
        }
      };

      TelTickFun();

      this.timerObj.telTime.obj = setInterval(TelTickFun, 1000);
    },
    /* 手机号发送验证码 */
    telCodeFun () {
      this.$refs["mobileBox"].validateField("account", (errorMessage) => {
        if (!errorMessage) {
          let params = {
            phone: this["mobileBox"].account,
            templateType: 102,
          };

          if (this.timerObj.telTime.loading) {
            return false;
          }

          this.timerObj.telTime.loading = true;

          telCodeApi(params)
            .then((res) => {
              const { code, message } = res;
              if (code == 200) {
                this.timerTelClick();
              } else {
                this.$message.error(message);
              }
              this.timerObj.telTime.loading = false;
            })
            .catch((err) => {
              this.timerObj.telTime.loading = false;
            });
        } else {
          this.$message.error(errorMessage);
        }
      });
    },
    fixIdentity () {
      this.fixIdentityVisible = false;
      this.identityBox = {};
      this.identityVisible = true;
    },
    submitIdentity () {
      this.$refs["identityBox"].validate((valid) => {
        if (valid) {
          const params = {
            ...this.identityBox,
          };

          identityApi(params).then((res) => {
            if (res.code == 200) {
              this.identityVisible = false;
            }
          });
        } else {

          return false;
        }
      });
    },

    submitMobile () {
      this.$refs["mobileBox"].validate((valid) => {
        if (valid) {
          const params1 = {
            ...this.mobileBox,
            bindType: 0,
          };

          bindAccountApi(params1).then((res) => {
            if (res.code == 200) {
              // this.getAccount();
              this.mobilelVisible = false;
            }
          });
        } else {

          return false;
        }
      });
    },
    ...mapMutations({
      SET_BUY_VISIBLE: "SET_BUY_VISIBLE",
      SET_CART_BADGE: "SET_CART_BADGE",
    }),

    getCartFun () {
      let that = this;
      that.loading = true;
      that.payStyle = [0, 1, 2];
      getCart().then((res) => {

        if (res && res.code === 200) {
          that.loading = false;
          let remove = false;
          res.data.forEach((item) => {
            if (item.priceType == 1) {
              remove = true;
            }
          });
          if (remove) {
            that.payStyles = [
              {
                key: 1,
                label: "收益积分",
              },
              {
                key: 2,
                label: "充值积分",
              },
            ];
            that.payStyle = [1, 2];
          }
          that.Get_CHECK_LIST = (res.data || []).map((item) => {
            return {
              ...item,
              price: item.price ? item.price : 0,
              checked: true,
            };
          });
        }
      });
      // 查询用户积分
      queryUserInfo().then((res) => {
        that.userInfo = res.data;
        that.userInfo.giftPoints = that.userInfo.giftPoints.toFixed(2)
        that.userInfo.incomePoints = that.userInfo.incomePoints.toFixed(2)
        that.userInfo.rechargePoints = that.userInfo.rechargePoints.toFixed(2)

      });
    },
    cardFun (inner) {
      inner = {
        ...inner,
        checked: !inner.checked,
      };
      const index = this.Get_CHECK_LIST?.findIndex(
        (item) => item.assetsId == inner.assetsId
      );

      this.Get_CHECK_LIST?.splice(index, 1, inner);

      let select = this.Get_CHECK_LIST?.filter((item) => item.checked);
      let remove = false;
      select.forEach((item) => {
        if (item.priceType == 1) {
          remove = true;
        }
      });
      if (remove) {
        this.payStyles = [
          {
            key: 1,
            label: "搜点",
          },
          {
            key: 2,
            label: "搜币",
          },
        ];
        this.payStyle = [1, 2];
      } else {
        this.payStyles = [
          {
            key: 0,
            label: "积分",
          },
          {
            key: 1,
            label: "搜点",
          },
          {
            key: 2,
            label: "搜币",
          },
        ];
        this.payStyle = [0, 1, 2];
      }
    },

    // 充值搜币
    coinsCharge () {
      this.payVisible = true
      this.inputNum = 50;
      this.amount = 50;
      clearInterval(this.wxtimer); // 清除定时器
      clearInterval(this.zfbtimer); // 清除定时器
      this.wxPay();
      this.zfbPay();
    },
    // 充值积分
    pointsCharge () {
      this.isHidden = true
    },

    userRealNameFunc (formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.userRealNameState = "0";
          this.userRealNamePopShow = false;
          // 去充值函数
          this.goRecharge();

        } else {

          return false;
        }
      });
    },

    // 关闭实名认证弹窗
    closeRealNamePop () {
      this.userRealNamePopShow = false;
    },

    handleClose () {
      this.SET_BUY_VISIBLE(false);
      sessionStorage.removeItem('totalpoints')
      sessionStorage.removeItem('TotalCoins')
      this.$store.commit('SET_TOTAL_POINTS', 0)
      this.$store.commit('SET_TOTAL_COINS', 0)
    },
    close () {
      this.payVisible = false;
      clearInterval(this.wxtimer); // 清除定时器
      clearInterval(this.zfbtimer);
    },
    qrcode (url, name) {
      // 前端根据 URL 生成支付二维码
      return new QRCode(name, {
        width: 120,
        height: 120,
        text: url,
        colorDark: "#000",
        colorLight: "#fff",
      });
    },
    async wxPay () {
      clearInterval(this.wxtimer); // 清除定时器
      const params = {
        amount: this.amount,
      };
      await wxQrCode(params).then((res) => {
        this.$refs.wxQrcodeImg.innerText = "";
        this.qrcode(res.data.codeUrl, "wxQrcodeImg"); // 根据这个值生成相对应的支付二维码
        if (res.data.outTradeNo) {
          this.wxtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryWxPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },
    async zfbPay () {
      clearInterval(this.zfbtimer); // 清除定时器
      const params = {
        amount: this.amount,
      };
      await zfbQrCode(params).then((res) => {
        let zxbIframeDiv = document.getElementById("zxbIframe");
        zxbIframeDiv.innerHTML = "";
        zxbIframeDiv.innerHTML =
          '<iframe id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe"></iframe>';
        let zxbIframe = document["zxbIframe"]
          ? document["zxbIframe"]
          : window.frames["zxbIframe"];

        zxbIframe.document.write(res.data.body);

        if (res.data.outTradeNo) {
          this.zfbtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryZfbPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },

    handleQueryWxPayStatus (sn) {
      let that = this;
      // 查询微信支付状态
      queryWxPayStatus({
        // 这里根据不同的后端接口去修改
        outTradeNo: sn,
      }).then((res) => {
        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          that.$message({
            type: "success",
            message: "支付成功！",
          });

          clearInterval(that.wxtimer); // 清除定时器
          clearInterval(that.zfbtimer); // 清除定时器
          // 查询用户积分
          queryUserInfo().then((res) => {
            that.userInfo = res.data;
            that.userInfo.giftPoints = that.userInfo.giftPoints.toFixed(2)
            that.userInfo.incomePoints = that.userInfo.incomePoints.toFixed(2)
            that.userInfo.rechargePoints = that.userInfo.rechargePoints.toFixed(2)
            // 关闭支付弹窗
            that.payVisible = false;
          });
          that.$parent.getAccount();
          that.$parent.getList();
        }
      });
    },
    handleQueryZfbPayStatus (sn) {
      let that = this;
      // 查询支付宝支付状态
      queryZfbPayStatus({
        // 这里根据不同的后端接口去修改
        outTradeNo: sn,
      }).then((res) => {
        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          that.$message({
            type: "success",
            message: "支付成功！",
          });
          clearInterval(that.wxtimer); // 清除定时器
          clearInterval(that.zfbtimer); // 清除定时器
          // 查询用户积分
          queryUserInfo().then((res) => {
            that.userInfo = res.data;
            that.userInfo.giftPoints = that.userInfo.giftPoints.toFixed(2)
            that.userInfo.incomePoints = that.userInfo.incomePoints.toFixed(2)
            that.userInfo.rechargePoints = that.userInfo.rechargePoints.toFixed(2)
            // 关闭支付弹窗
            that.payVisible = false;
          });
          that.$parent.getAccount();
          that.$parent.getList();
        }
      });
    },
    billClick () {
      if (this.billing == "其他") {
        this.amount = this.inputNum;
      } else {
        this.amount = this.billing;
      }
      this.wxPay();
      this.zfbPay();
    },
    closePayDialog () {
      this.payBtn = true;
      clearInterval(this.timer); // 清除定时器
    },
    handleChange () {
      this.amount = this.inputNum;
      this.wxPay();
      this.zfbPay();
    },

    // 确认支付
    okFun () {
      const params = {
        assetsIds: this.GET_JS_LISTS?.map((item) => item.assetsId).join(","),
        incomePointsBalance: this.SYPoins,
        rechargePointsBalance: this.SYcoins
      };
      this.loading = true;

      settlementCartApi(params)
        .then((res) => {

          if (res.code == 200) {
            this.$message({
              message: "结算成功",
              type: "success",
            });

            // 处于购物车页面要重新调用请求接口，或者重新刷新
            if (this.$route.path === '/user/myDownload') {
              this.$router.go(0)
            }
            // 跳转到下载页面
            this.$router.push("/user/myDownload");

            this.SET_BUY_VISIBLE(false);
            let num = this.GET_CART_BADGE - select.length;
            this.SET_CART_BADGE(num ? num : "");

          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    GET_BUY_VISIBLE () {
      if (this.GET_BUY_VISIBLE && this.GET_USER_INFO.token) {
        this.getCartFun();
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__title {
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: inline-block;
  margin-top: 5px;

}

.pay-head {
  padding-left: 10px;
  text-align: left;
  font-size: 16px;
}

.pay-style {
  padding: 10px;
  text-align: left;
  font-size: 16px;
}

.pay-num {
  padding: 0 20px;
  float: right;
  font-size: 16px;
  color: #fa5c5c;
}

.goods-list {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 10px 0;
}

.time {
  font-size: 13px;
  color: #000;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.marginB {
  margin-bottom: 20px;
}

.card-item {
  position: relative;
  width: 270px;
  height: 347px;
  cursor: pointer;

  .image {
    width: 270px;
    height: 270px;
  }

  .des {
    padding: 14px;
    color: #000;
    font-weight: 400;
    font-size: 16px;
  }

  .time {
    font-size: 12px;
  }
}

.item-checked-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
}

.item-checked {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 20px;
  color: #fa5c5c;
}

.recharge-link {
  color: #409eff;
  font-size: 16px;
}

.nowVaila {
  width: 600px;
  height: 110px;
  background: linear-gradient(90deg, #044e48, #068a71);
  color: #fff;
  border-radius: 8px;

  .ipt {
    width: 15px;
    height: 15px;
  }
}

/deep/ .nowVaila[data-v-1f9192a9] {
  color: #999;
}

.content {
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
    url('../assets/member/bglogo.png');
  background-repeat: no-repeat;
  background-size: 25%;
  background-position: 330px -1px;
  user-select: none;


  .payTxt_1,
  .payTxt_5 {
    font-size: 18px;
    font-weight: bold;
    color: #000;
    margin-top: -20px;
  }

  .payTxt_2,
  .payTxt_6 {
    height: 30px;
    color: #f00;
    font-size: 16px;
    font-weight: bold;
    margin-top: 16px;

    .payTxt_7 {
      margin-right: 76px;
    }

    .coinsInsu {
      cursor: pointer;
      margin-right: -80px;
    }
  }

  .payTxt_3 {
    margin-right: 80px;
  }

  .payTxt_5 {
    margin-top: 16px;
  }

  .line {
    margin-top: 10px;
    margin-bottom: 16px;
    width: 100%;
    height: 1px;
    background-color: #e1dede;
  }

  .line1 {
    width: 70%;
  }

  .payTxt_9 {
    margin-bottom: 40px;
    margin-left: 20px;
    color: #E0B58C;
    font-weight: bold;

    .payTxt_10,
    .payTxt_14 {
      font-size: 18px;
    }

    .payTxt_11 {
      font-size: 14px;
    }

    .payTxt_12 {
      margin-left: 20px;
      font-size: 18px;
    }

    .dot {
      font-size: 30px;
      font-weight: bold;
      position: absolute;
      left: 26px;
      top: 245px;
    }
  }

  .payTxt_15 {

    .payTxt_16 {
      position: absolute;
      bottom: 22px;
      right: 135px;
      color: #666;
    }

    .payTxt_17 {
      position: absolute;
      bottom: 22px;
      right: 18px;

      .gobuyBtn {
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: none;
        color: #79B35D;
        background-color: #F0F9EC;
        border-radius: 5px;
        border: 1px solid #79B35D;
      }

      .gobuyBtn:hover {
        color: #F0F9EC;
        background-color: #79B35D;
      }
    }
  }


}

/deep/.el-dialog {
  border-radius: 10px;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.coinsInsu,
.pointsInsu {
  cursor: pointer;
  font-size: 12px;
  color: #f20606;
  margin-left: 5px;

  a {
    font-size: 14px;
    color: #409eff;
    text-decoration: underline;
  }
}

.coinsInsu {

  margin-right: -90px;
}

.membertxt {
  margin-left: 20px;
}
</style>
